import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _actionProviderSPIConfig = { actionConfig: '_actionSPIConfig' };
var _actionSPIConfig = { icon: '_commonImage' };
var _adminConfigurableTextInput = {
    requiredSettings: 'google.protobuf.FieldMask',
    adminConfigurableSettings: 'google.protobuf.FieldMask',
};
var _authenticatorConfig = { expectedInputs: '_expectedInputs' };
var _commonImage = { urlExpirationDate: 'google.protobuf.Timestamp' };
var _completeSetupCountRequest = {};
var _completeSetupCountResponse = {};
var _component = { compData: '_componentData' };
var _componentData = {
    widgetComponentData: '_widgetComponentData',
    widgetOutOfIframeData: '_widgetOutOfIframeComponentData',
    studioWidgetComponentData: '_studioWidgetComponentData',
    shippingLabelCarrier: '_shippingLabelCarrierSpiConfig',
    fictionalShippingProvider: '_shippingProviderConfig',
    automationsActionProvider: '_actionProviderSPIConfig',
    identityAuthenticator: '_authenticatorConfig',
    multilingualTranslationSchema: '_multilingualTranslationSchema',
};
var _editorPresence = { presetsEditorPresence: '_presetEditorPresence' };
var _expectedInputs = {
    expectedStartInputs: '_predefinedExpectedInput',
    expectedVerifyInputs: '_predefinedExpectedInput',
};
var _freeTrialData = { endDate: 'google.protobuf.Timestamp' };
var _image = { urlExpirationDate: 'google.protobuf.Timestamp' };
var _managedApp = { premiumInfo: '_premiumInfo', components: '_component' };
var _managedAppsRequest = {};
var _managedAppsResponse = { managedApps: '_managedApp' };
var _managedAppsStatusRequest = {};
var _managedAppsStatusResponse = {};
var _multilingualTranslationSchema = { referenceData: '_schema' };
var _packageDimension = {
    width: 'DOUBLE',
    length: 'DOUBLE',
    height: 'google.protobuf.DoubleValue',
};
var _packageType = { dimension: '_packageDimension', image: '_image' };
var _predefinedExpectedInput = {
    configuration: '_predefinedExpectedInputConfiguration',
};
var _predefinedExpectedInputConfiguration = {
    textInput: '_adminConfigurableTextInput',
};
var _premiumInfo = { freeTrialData: '_freeTrialData' };
var _presetEditorPresence = { wixMediaThumbnail: '_commonImage' };
var _schema = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    fields: 'Map#_v1SchemaField',
};
var _shippingLabelCarrierSpiConfig = { packageTypes: '_packageType' };
var _shippingProviderConfig = { shippingPrice: 'DOUBLE' };
var _studioWidgetComponentData = {
    widgetDisplay: '_widgetDisplay',
    editorPresence: '_editorPresence',
};
var _v1SchemaField = { index: 'google.protobuf.DoubleValue' };
var _widgetComponentData = { widgetDisplay: '_widgetDisplay' };
var _widgetDisplay = { price: 'google.protobuf.FloatValue' };
var _widgetOutOfIframeComponentData = { widgetData: '_widgetComponentData' };
function resolveComWixpressDevcenterManagedappsManagedAppsUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/managed-apps',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/managed-apps',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/managed-apps',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/managed-apps',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/managed-apps',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/managed-apps',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/managed-apps',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/managed-apps',
                destPath: '',
            },
        ],
        'wixapis.com': [
            {
                srcPath: '/managed-apps',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** retrieves all the apps a site owner can manage for a given meta-site in context */
export function managedApps(payload) {
    var _a = serializer(_managedAppsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_managedAppsResponse, {
        _actionProviderSPIConfig: _actionProviderSPIConfig,
        _actionSPIConfig: _actionSPIConfig,
        _adminConfigurableTextInput: _adminConfigurableTextInput,
        _authenticatorConfig: _authenticatorConfig,
        _commonImage: _commonImage,
        _component: _component,
        _componentData: _componentData,
        _editorPresence: _editorPresence,
        _expectedInputs: _expectedInputs,
        _freeTrialData: _freeTrialData,
        _image: _image,
        _managedApp: _managedApp,
        _multilingualTranslationSchema: _multilingualTranslationSchema,
        _packageDimension: _packageDimension,
        _packageType: _packageType,
        _predefinedExpectedInput: _predefinedExpectedInput,
        _predefinedExpectedInputConfiguration: _predefinedExpectedInputConfiguration,
        _premiumInfo: _premiumInfo,
        _presetEditorPresence: _presetEditorPresence,
        _schema: _schema,
        _shippingLabelCarrierSpiConfig: _shippingLabelCarrierSpiConfig,
        _shippingProviderConfig: _shippingProviderConfig,
        _studioWidgetComponentData: _studioWidgetComponentData,
        _v1SchemaField: _v1SchemaField,
        _widgetComponentData: _widgetComponentData,
        _widgetDisplay: _widgetDisplay,
        _widgetOutOfIframeComponentData: _widgetOutOfIframeComponentData,
    }).fromJSON;
    function __managedApps(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.managedapps.v1.managed_app',
            method: 'GET',
            methodFqn: 'com.wixpress.devcenter.managedapps.ManagedApps.ManagedApps',
            url: resolveComWixpressDevcenterManagedappsManagedAppsUrl({
                protoPath: '/v1/managed-apps',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __managedApps.fromReq = fromReq;
    __managedApps.__isAmbassador = true;
    return __managedApps;
}
/** return the current status of requested app ids in a given meta-site in context */
export function managedAppsStatus(payload) {
    var _a = serializer(_managedAppsStatusRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_managedAppsStatusResponse, {}).fromJSON;
    function __managedAppsStatus(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.managedapps.v1.managed_app',
            method: 'GET',
            methodFqn: 'com.wixpress.devcenter.managedapps.ManagedApps.ManagedAppsStatus',
            url: resolveComWixpressDevcenterManagedappsManagedAppsUrl({
                protoPath: '/v1/managed-app-status',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __managedAppsStatus.fromReq = fromReq;
    __managedAppsStatus.__isAmbassador = true;
    return __managedAppsStatus;
}
/** returns the count of the apps that require complete setup actions */
export function completeSetupCount(payload) {
    var _a = serializer(_completeSetupCountRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_completeSetupCountResponse, {}).fromJSON;
    function __completeSetupCount(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.managedapps.v1.managed_app',
            method: 'GET',
            methodFqn: 'com.wixpress.devcenter.managedapps.ManagedApps.CompleteSetupCount',
            url: resolveComWixpressDevcenterManagedappsManagedAppsUrl({
                protoPath: '/v1/complete-setup-count',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __completeSetupCount.fromReq = fromReq;
    __completeSetupCount.__isAmbassador = true;
    return __completeSetupCount;
}
//# sourceMappingURL=http.impl.js.map